var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-configuration"},[_c('img',{staticClass:"button-configuration__icon",attrs:{"src":"/img/icons/svg/surface1.svg","alt":""}}),_c('span',[_vm._v("Configurações")])])
}]

export { render, staticRenderFns }